var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c("h1", { staticClass: "mt-0" }, [
        _vm._v(_vm._s(_vm.$t("invoiceDetail")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: 17 } },
            [
              _c(
                "el-card",
                { staticClass: "mb-5" },
                [
                  _vm.currentInvoice
                    ? _c("document-detail", {
                        attrs: {
                          document: _vm.currentInvoice,
                          "document-type": "invoice"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("el-card", { staticClass: "mb-5" }, [
                _c("h4", { staticClass: "mb-20" }, [
                  _vm._v(_vm._s(_vm.$t("shared.attachments")))
                ]),
                _vm._v(" "),
                _vm.currentInvoice
                  ? _c(
                      "div",
                      { staticClass: "attachments" },
                      [
                        _vm._l(_vm.currentInvoice.attachments, function(
                          attachment,
                          index
                        ) {
                          return _c(
                            "el-button",
                            {
                              key: index,
                              attrs: { type: "text" },
                              on: { click: _vm.handleAttachments }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(attachment.name) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mt-5",
                            attrs: { type: "text" },
                            on: { click: _vm.handleAttachments }
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("invoice-disputes.no_attachments")
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ]
                        )
                      ],
                      2
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.currentInvoice && _vm.currentInvoice.custom_fields
                ? _c(
                    "el-card",
                    { staticClass: "mb-5" },
                    [
                      _c("h4", { staticClass: "mb-20" }, [
                        _vm._v(_vm._s(_vm.$t("shared.custom_fields")))
                      ]),
                      _vm._v(" "),
                      _vm.userInterfaceDetails &&
                      _vm.userInterfaceDetails.custom_field_definitions
                        ? _c("custom-fields-list", {
                            attrs: {
                              "custom-field-definitions":
                                _vm.userInterfaceDetails
                                  .custom_field_definitions,
                              "custom-fields": _vm.currentInvoice.custom_fields
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "mb-10",
                          attrs: { size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.showCustomFields = !_vm.showCustomFields
                            }
                          }
                        },
                        [
                          _vm.showCustomFields
                            ? _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("shared.hide_custom_fields")
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("shared.show_custom_fields")
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showCustomFields
                        ? _c("json-editor", {
                            attrs: { value: _vm.currentInvoice.custom_fields }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-card",
                { staticClass: "mb-5" },
                [
                  _vm._l(_vm.invoiceFiles, function(file) {
                    return [
                      _c(
                        "el-button",
                        {
                          key: `${file.name}-btn`,
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              return _vm.onDownload(file)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " Download " +
                              _vm._s(_vm.$tc("invoice", 1).toLowerCase()) +
                              " "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isUriAttachment(file) && !file.uri.startsWith("s3")
                        ? _c("pdf", {
                            key: file.name,
                            attrs: { src: file.uri }
                          })
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 7 } },
            [
              _c(
                "el-card",
                [
                  _vm.currentInvoice &&
                  _vm.currentInvoice.recipient_by_reference &&
                  _vm.currentInvoice.reference
                    ? [
                        _c("actions-notes", {
                          attrs: {
                            "is-invoice-view": true,
                            recipient: _vm.currentInvoice.recipient
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentInvoice
        ? _c("attachments-dialog", {
            attrs: {
              participant: _vm.$store.state.risolto.selectedParticipantStore,
              "legal-entity": _vm.currentInvoice.legal_entity,
              visible: _vm.attachmentsDialogVisible,
              "file-list": _vm.currentInvoice.attachments,
              "on-upload": _vm.handleAttachmentUpload,
              "on-remove": _vm.handleAttachmentRemove
            },
            on: {
              "dialog-close": function($event) {
                _vm.attachmentsDialogVisible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }